/**
 * Project settings includes: TOKEN_NAME: access token
 */
export enum appConfig {
  TOKEN_NAME = "persist:rtk:access_token",
  AUTH_LINK = "auth_link",
}
export const VENDOR_THEME_PREFIX_NAME = "vendorThemePrefix";
